import type { FC } from "react";
import { OrderGetHelp } from "/@/pages/orders/OrderGetHelp";
import { OrderGetRedo } from "/@/pages/orders/OrderGetRedo";
import { CenteredModal } from "./CenteredModal";
import type { OrderPageState } from "./useOrderPage";

type OrderRequestModalsProps = {
  state: OrderPageState;
};

// V1 only: V2 renders the help and redo requests as inline panels.
export const OrderRequestModals: FC<OrderRequestModalsProps> = ({ state }) => {
  const {
    order,
    refetch,
    requests,
    actions,
    bankHolidays,
    connectedUserEmail,
  } = state;

  if (!order) {
    return null;
  }

  return (
    <>
      <CenteredModal modal={requests.help}>
        <OrderGetHelp
          order={order}
          refetch={refetch}
          closeModal={requests.help.close}
          id={actions.getHelpTempId()}
        />
      </CenteredModal>
      <CenteredModal modal={requests.redo}>
        <OrderGetRedo
          order={order}
          closeModal={() => {
            refetch();
            requests.redo.close();
          }}
          bankHolidays={bankHolidays}
          userEmail={connectedUserEmail}
        />
      </CenteredModal>
    </>
  );
};
